import { IProduct, IStoreProduct } from "../models/api/IProduct";
import { ProductViewSource } from "../models/api/IClientEvent";

export type ProductModalMessage = {
    type: "error" | "info";
    text: string;
};
export type ProductModalEntry = {
    product: IProduct;
    meta?: ProductModalMeta;
};

export type ProductModalItem = {
    message?: ProductModalMessage;
    entries: ProductModalEntry[];
    hasParams?: boolean;
};

export type ProductModalMeta = {
    source?: ProductViewSource;
};

export type ProductModalInput = {
    message?: ProductModalMessage;
    product?: IStoreProduct | IProduct;
    hasParams?: boolean;
};

export function isProductModalInput(obj: ProductModalInput | IStoreProduct | IProduct): obj is ProductModalInput {
    return (<ProductModalInput>obj).product !== undefined || (<ProductModalInput>obj).message !== undefined;
}
